export default "__VITE_ASSET__DSkGrfr4__"